<template>
  <FlotoAnchorLink :aria-label="$t('restore')" @click="triggerAction">
    <MIcon name="trash-undo-alt" class="action-menu-icon" />
    <span class="ml-1 action-menu-text">
      {{ $t('restore') }}
    </span>
    <FlotoConfirmModal
      :open="showModal"
      prevent-auto-close-on-confirm
      :processing="processing"
      @hide="showModal = false"
      @confirm="handleConfirmAction"
    >
      <template v-slot:icon>
        <MIcon name="trash-undo-alt" class="w-full text-primary" size="2x" />
      </template>
      <template v-slot:message>
        {{
          $t('confirm_restore', {
            resource: $tc(moduleName),
          })
        }}
      </template>
    </FlotoConfirmModal>
  </FlotoAnchorLink>
</template>

<script>
export default {
  name: 'Unarchive',
  props: {
    moduleName: { type: String, required: true },
    handleRestoreItems: { type: Function, default: undefined },
  },
  data() {
    return {
      showModal: false,
      processing: false,
    }
  },
  methods: {
    handleConfirmAction() {
      this.$emit('done')
      if (this.handleRestoreItems) {
        this.processing = true
        this.handleRestoreItems()
          .then(() => {
            this.showModal = false
          })
          .finally(() => {
            this.showModal = false
            this.processing = false
          })
      } else {
        this.showModal = false
      }
    },
    triggerAction() {
      this.$emit('trigger')
      // show modal after dropdown is hide
      setTimeout(() => {
        this.showModal = true
      }, 400)
    },
  },
}
</script>
